/* eslint-disable */
window.fp_scrollHorizontallyExtension = function () {
  var e = this,
    n = window.fp_utils,
    a = window.fullpage_api,
    c = n,
    d = n.$,
    t = a.getFullpageData(),
    f = t.options,
    i = t.internals,
    s = '.fp-section',
    p = '.fp-slide'
  ;(e.getScrollSection = function (e, n) {
    var t,
      i = d('.fp-section.active')[0],
      o = d(p, i).length,
      l = f.scrollHorizontally && 1 < o,
      r = 1 === d(s).length
    if (l && window.isSlide)
      if (((t = d('.fp-slide.active', i)[0]), 'down' === e)) {
        if (c.index(t) + 1 !== o || r) return a.moveSlideRight
      } else if (c.index(t) || r) return a.moveSlideLeft
    return n
  }),
    (e.c = i.c)
  var o = e['common'.charAt(0)]
  return (
    'complete' === document.readyState && o('scrollHorizontally'),
    window.addEventListener('load', function () {
      o('scrollHorizontally')
    }),
    e
  )
}
